import StudentPage from '../components/StudentPage';
import dayjs from 'dayjs';
import advancedFormat from "dayjs/plugin/advancedFormat";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Chip from '@mui/material/Chip';
import { AttachMoney } from '@mui/icons-material';
import useStudentContext from 'hooks/useStudentContext';
import { formatCents } from 'utils/formatCurrency';

function Ledger(): JSX.Element {
    const { ledger, loadingLedger } = useStudentContext();

    dayjs.extend(advancedFormat);

    const columns: GridColDef[] = [
        {
            field: 'date',
            headerName: 'Date',
            type: 'date',
            width: 130,
            sortable: false,
            valueFormatter: (value) => {
                if (value === null) return null;
                return dayjs(value as string)
                    .format('MM/DD/YYYY');
            },
        },
        {
            field: 'type',
            headerName: 'Type',
            type: 'singleSelect',
            sortable: false,
            width: 130,
            renderCell: (params) => {
                switch (params.value) {
                    case 'charge':
                        return (
                            <Chip
                                sx={{ width: '100%!important', fontWeight: 'bold' }}
                                // sx={{ fontWeight: 'bold' }}
                                icon={<AttachMoney fontSize="medium" />}
                                size="small"
                                label="Charge"
                                color="error"
                                variant="outlined"
                            />
                        );
                    case 'payment':
                        return (
                            <Chip
                                sx={{ width: '100%!important', fontWeight: 'bold' }}
                                // sx={{ fontWeight: 'bold' }}
                                icon={<AttachMoney fontSize="medium" />}
                                size="small"
                                label="Payment"
                                color="success"
                                variant="outlined"
                            />
                        );
                    case 'refund':
                        return (
                            <Chip
                                sx={{ width: '100%!important', fontWeight: 'bold' }}
                                // sx={{ fontWeight: 'bold' }}
                                icon={<AttachMoney fontSize="medium" />}
                                size="small"
                                label="Refund"
                                color="primary"
                                variant="outlined"
                            />
                        );
                }
            },
        },
        {
            field: 'memo',
            headerName: 'Memo',
            type: 'string',
            // width: 130,
            flex: 1,
            sortable: false,
        },
        {
            field: 'payment_method',
            headerName: 'Method',
            // type: 'string',
            width: 130,
            sortable: false,
            valueGetter: (_value, row) => {
                return row?.payment_method?.name ?? '';
            },
        },
        {
            field: 'debit',
            headerName: 'Debit',
            type: 'string',
            width: 130,
            sortable: false,
            valueFormatter: (value) => (value ? formatCents(value) : '')
        },
        {
            field: 'credit',
            headerName: 'Credit',
            type: 'string',
            width: 130,
            sortable: false,
            valueFormatter: (value) => (value ? formatCents(value) : '')

        },
        {
            field: 'balance',
            headerName: 'Balance',
            type: 'string',
            width: 130,
            sortable: false,
            valueFormatter: (value) => (value ? formatCents(value) : '')
        },
    ];

    return (
        <StudentPage title={`Account Balance: ${formatCents(ledger?.[ledger.length - 1]?.balance ?? 0)}`}>
            <DataGrid
                disableColumnMenu
                columns={columns}
                loading={loadingLedger}
                rows={ledger ?? []}
                // slots={{
                //   toolbar: CustomToolbar,
                //   footer: CustomFooterStatusComponent,
                // }}
                // slotProps={{
                //   footer: {
                //     balance: formatCurrency(ledgerEntries[ledgerEntries.length-1]?.balance ?? "0.00")
                //   },
                // }}
                sx={{
                    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
                        outline: 'none',
                    },
                    '& .MuiInputBase-root': {
                        width: 'auto!important',
                    },
                }}
            />
        </StudentPage>

    );
}

export default Ledger;

